import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { BetBuilderPick } from "@data-types/bet-booster/BetBuilderPicks";

export default observer(function BetBuilderPicksPopupHeader(props: {
	slipNumber: number;
	slip: BetBuilderPick;
	isLive: boolean;
	cb: () => void;
}) {
	const t = useTranslation().t;

	return (
		<div className="popup__header popup--qp__header popup--bbp__header">
			<div className="popup__title">
				<i className="u-icon u-icon--base u-icon--bb--active u-mar--right--xtny" />

				<div className="popup__title__inner">
					{props.slipNumber != null && (
						<div className="popup__title__inner">
							{t("QUICK_PLAY.BET_BUILDER_PICKS.BB_CARD_TITLE")} #
							{props.slipNumber + 1}
						</div>
					)}
				</div>

				{props.isLive && (
					<span className="popup__tag tag tag--sml tag--live--ghost tag--bolder u-type--xsml">
						{t<string>("COMMON.LIVE")}
					</span>
				)}
			</div>

			<button
				type="button"
				className="popup__close btn btn--square btn--square--sml btn--primary--inverted"
				onClick={props.cb}
			>
				<i className="u-icon u-icon--tny u-icon--close u-color--text--secondary" />
			</button>
		</div>
	);
});
